import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s Discuss Your Project</h2>
                        </div>
                        <p>Embark on a journey of seamless app maintenance and unparalleled support by engaging with TekRevol. Our commitment to excellence, coupled with a team of dedicated experts, ensures that your project receives the attention it deserves. From identifying unique maintenance needs to providing tailored solutions, TekRevol is composed to be your trusted partner for app maintenance and support services. Let's discuss your project today and pave the way for sustained success in the dynamic world of mobile applications.</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;